export default "__VITE_ASSET__Dpaut5a$__"